/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PenthouseInputs */

const en_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penthouse`)
};

const es_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ático`)
};

const fr_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penthouse`)
};

const de_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penthouse`)
};

const ja_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペントハウス`)
};

const zh_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶层公寓`)
};

const ar_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شقة بنتهاوس`)
};

const id_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griya Tawang`)
};

const it_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attico`)
};

const ru_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пентхаус`)
};

const pt_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura`)
};

const ko_val_penthouse = /** @type {(inputs: Val_PenthouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`펜트하우스`)
};

/**
* | output |
* | --- |
* | "Penthouse" |
*
* @param {Val_PenthouseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_penthouse = /** @type {((inputs?: Val_PenthouseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PenthouseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_penthouse(inputs)
	if (locale === "es") return es_val_penthouse(inputs)
	if (locale === "fr") return fr_val_penthouse(inputs)
	if (locale === "de") return de_val_penthouse(inputs)
	if (locale === "ja") return ja_val_penthouse(inputs)
	if (locale === "zh") return zh_val_penthouse(inputs)
	if (locale === "ar") return ar_val_penthouse(inputs)
	if (locale === "id") return id_val_penthouse(inputs)
	if (locale === "it") return it_val_penthouse(inputs)
	if (locale === "ru") return ru_val_penthouse(inputs)
	if (locale === "pt") return pt_val_penthouse(inputs)
	return ko_val_penthouse(inputs)
});